module.exports = __webpack_public_path__ + "static/media/Codes_Scan_Selected.46e7e2a0.svg";